const LEGACY_PORT_STARBOARD_PATTERN = /^C(\d+)(P|S)$/i;

export const formatTankReferences = (tankReferences = []) => {
  if (!Array.isArray(tankReferences) || tankReferences.length === 0) {
    return "";
  }

  const normalizedReferences = tankReferences
    .map((reference) => String(reference || "").trim())
    .filter(Boolean);

  if (
    normalizedReferences.length > 0 &&
    normalizedReferences.every((reference) =>
      LEGACY_PORT_STARBOARD_PATTERN.test(reference)
    )
  ) {
    const tankGroups = {};

    normalizedReferences.forEach((tank) => {
      const match = tank.match(LEGACY_PORT_STARBOARD_PATTERN);
      if (!match) return;

      const [, number, side] = match;
      if (!tankGroups[number]) {
        tankGroups[number] = new Set();
      }
      tankGroups[number].add(side.toUpperCase());
    });

    const bothSides = [];
    const onlyP = [];
    const onlyS = [];

    Object.entries(tankGroups).forEach(([number, sides]) => {
      if (sides.has("P") && sides.has("S")) {
        bothSides.push(number);
      } else if (sides.has("P")) {
        onlyP.push(number);
      } else if (sides.has("S")) {
        onlyS.push(number);
      }
    });

    const result = [];
    if (bothSides.length > 0) result.push(`${bothSides.join(", ")} P/S`);
    if (onlyP.length > 0) result.push(`${onlyP.join(", ")} P`);
    if (onlyS.length > 0) result.push(`${onlyS.join(", ")} S`);
    return result.join(", ");
  }

  return normalizedReferences.join(", ");
};

